import React, { useEffect, useState } from "react";
import { formatDate } from "ultils/date-formatter";

interface AddEditTenantFormProps {
  propertyDetails: any; // Passed prop containing property details
  onTenantUpdate: (
    updatedDetails: any,
    e: React.FormEvent,
    editMode: boolean
  ) => void; // Callback for parent to handle updates
  unitDetails: any;
  tenantDetails: any;
}

const AddEditTenantForm: React.FC<AddEditTenantFormProps> = ({
  propertyDetails,
  onTenantUpdate,
  unitDetails,
  tenantDetails,
}) => {
  const [editMode, setEditMode] = useState<boolean>(false);
  const [tenantDetailsForm, setTenantDetailsForm] = useState<any>({});

  useEffect(() => {
    if (
      tenantDetails !== null &&
      tenantDetails !== undefined &&
      Object.keys(tenantDetails).length !== 0
    ) {
      setTenantDetailsForm(tenantDetails);
      setEditMode(true);
    }
  }, [tenantDetails]);

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { name, value, type } = e.target;
    const isCheckbox = type === "checkbox";

    setTenantDetailsForm((prev: any) => ({
      ...prev,
      [name]: isCheckbox ? (e.target as HTMLInputElement).checked : value,
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    onTenantUpdate(tenantDetailsForm, e, editMode);
  };

  return (
    <form onSubmit={handleSubmit} className="add-property-form">
      {/* Street Address */}

      {/* First Name */}
      <div className="form-group">
        <label htmlFor="firstName">First Name:</label>
        <input
          type="text"
          id="firstName"
          name="firstName"
          value={tenantDetailsForm.firstName}
          onChange={handleChange}
          required
          placeholder="Enter first name"
        />
      </div>

      {/* Last Name */}
      <div className="form-group">
        <label htmlFor="lastName">Last Name:</label>
        <input
          type="text"
          id="lastName"
          name="lastName"
          value={tenantDetailsForm.lastName}
          onChange={handleChange}
          required
          placeholder="Enter last name"
        />
      </div>

      <div className="form-group">
        <label htmlFor="rentDueDay">What day of the month is rent due?</label>
        <select
          id="rentDueDay"
          name="rentDueDay"
          value={tenantDetailsForm.rentDueDay}
          onChange={handleChange}
          required
        >
          {[...Array(31)].map((_, i) => (
            <option key={i + 1} value={i + 1}>
              {i + 1}
            </option>
          ))}
        </select>
      </div>

      {/* Phone Number */}
      <div className="form-group">
        <label htmlFor="phoneNumber">Phone Number:</label>
        <input
          type="text"
          id="phoneNumber"
          name="phoneNumber"
          value={tenantDetailsForm.phoneNumber}
          onChange={handleChange}
          placeholder="Enter phone number"
        />
      </div>

      {/* Email */}
      <div className="form-group">
        <label htmlFor="email">Email:</label>
        <input
          type="email"
          id="email"
          name="email"
          value={tenantDetailsForm.email}
          onChange={handleChange}
          placeholder="Enter email address"
        />
      </div>

      {/* Employed */}
      <div className="form-group">
        <label htmlFor="employed">Employed:</label>
        <input
          type="checkbox"
          id="employed"
          name="employed"
          checked={tenantDetailsForm.employed}
          onChange={handleChange}
        />
      </div>

      {/* Employer */}
      <div className="form-group">
        <label htmlFor="employer">Employer:</label>
        <input
          type="text"
          id="employer"
          name="employer"
          value={tenantDetailsForm.employer}
          onChange={handleChange}
          placeholder="Enter employer name"
        />
      </div>

      {/* Income */}
      <div className="form-group">
        <label htmlFor="income">Income:</label>
        <input
          type="text"
          id="income"
          name="income"
          value={tenantDetailsForm.income}
          onChange={handleChange}
          placeholder="Enter income"
        />
      </div>

      {/* Notes */}
      <div className="form-group">
        <label htmlFor="notes">Notes:</label>
        <textarea
          id="notes"
          name="notes"
          value={tenantDetailsForm.notes}
          onChange={handleChange}
          placeholder="Enter any additional notes"
        />
      </div>

      {/* Lease Start Date */}
      <div className="form-group">
        <label htmlFor="leaseStartDate">Lease Start Date:</label>
        <input
          type="date"
          id="leaseStartDate"
          name="leaseStartDate"
          value={
            formatDate(
              new Date(tenantDetailsForm.leaseStartDate),
              "yyyy-MM-dd"
            ) ?? ""
          }
          onChange={handleChange}
          required
        />
      </div>

      {/* Lease End Date */}
      <div className="form-group">
        <label htmlFor="leaseEndDate">Lease End Date:</label>
        <input
          type="date"
          id="leaseEndDate"
          name="leaseEndDate"
          value={
            formatDate(
              new Date(tenantDetailsForm.leaseEndDate),
              "yyyy-MM-dd"
            ) ?? ""
          }
          onChange={handleChange}
        />
      </div>

      {/* Active */}
      <div className="form-group">
        <label htmlFor="active">Active:</label>
        <input
          type="checkbox"
          id="active"
          name="active"
          checked={tenantDetailsForm.active}
          onChange={handleChange}
        />
      </div>

      <button type="submit" className="submit-button">
        {editMode ? "Update Tenant" : "Add Tenant"}
      </button>
    </form>
  );
};

export default AddEditTenantForm;
